import React, { useState, useEffect, useRef } from 'react'
import { Dialog } from '@mui/material'
import { DialogContentWrapper, Percentage, Msg } from './style'
import { Loader } from '../'
// import LoaderProgressive from './loaderProgressive'

const BlockingLoader = (props) => {
  const { msg = undefined, value, maxValue, minPercentage = 0, maxPercentage = 100, fakeLoading=false } = props
  const [fakePercentage, setFakePercentage] = useState(0)

  let percentage = Math.round((value / maxValue) * maxPercentage) || null
  if (percentage === 100) {
    percentage = 99
  }

  const timer = useRef(null)
  const updateFakePercentage = (percent) => {
    setFakePercentage(percent)
    timer.current = setTimeout(() => {
      setFakePercentage(percent + 1)
      updateFakePercentage(percent + 1)
    }, 4000)
  }

  useEffect(() => {
    if (percentage && percentage < 95) {
      if (timer.current) clearTimeout(timer.current)
      setFakePercentage(percentage)
      updateFakePercentage(percentage)
    } else if (percentage > 99) {
      setFakePercentage(98)
    }
    return () => {
      clearTimeout(timer.current)
    }
  }, [percentage])

  useEffect(() => {
    if (fakePercentage > 99) {
      clearTimeout(timer.current)
      setFakePercentage(98)
    }
  }, [fakePercentage])

  useEffect(() => {
    if (!fakeLoading || fakePercentage >= 99) return;

    const getDelay = (percentage) => {
      if (percentage > 90) return 8000;
      if (percentage > 70) return 3500;
      if (percentage > 40) return 2000;
      if (percentage % 5 === 0) return 2000;
      return 700;
    }
    const delay = getDelay(fakePercentage);
    const timer = setTimeout(() => {
      setFakePercentage((prev) => prev + 1);
    }, delay);

    return () => clearTimeout(timer);
  }, [fakeLoading, fakePercentage]);


  return (
    <Dialog id='dialog-loading' open disableEscapeKeyDown>
      <DialogContentWrapper>
        {<Loader width={70} height={70} />}
        {/* {maxValue === 0 && <Loader width={70} height={70} />} */}
        {/* {maxValue > 0 && <LoaderProgressive width={70} height={70} percentage={percentage} />} */}
        {/* {maxValue > 0 && percentage > 0 && <Percentage>{percentage}% / ( {fakePercentage}% ) </Percentage> } */}
        {(!fakeLoading) && maxValue > 0 && fakePercentage >= 0 && (
          <Percentage>{fakePercentage + minPercentage}%</Percentage>
        )}
        {fakeLoading && maxValue > 0 && fakePercentage >= 0 && (
          <Percentage>{fakePercentage}% ...</Percentage>
        )}
        {msg && <Msg>{msg}</Msg>}
      </DialogContentWrapper>
    </Dialog>
  )
}

export default BlockingLoader
